import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _isArray from 'lodash/isArray'
import Button, { TYPES } from 'components/Button'
import { ICON_TYPES } from 'components/Icon.v2'
import { requestAnimationFrame } from 'services/animate'

function getBackToTopClassName (classes, displayed) {
  const css = ['back-to-top'].concat(_isArray(classes) ? classes : [])
  if (displayed) {
    css.push('back-to-top--active')
  }
  return css.join(' ')
}

function backToTopOnClick () {
  if (global && global.scrollTo) {
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    })
  }
}

class BackToTop extends Component {
  constructor (props) {
    super(props)
    this.state = {
      displayed: false,
    }
  }

  componentDidMount () {
    this.setScrollListener()
  }

  componentWillUnmount () {
    this.destroyScrollListener()
  }

  setScrollListener = () => {
    this._displayAfterScroll = this.displayAfterScroll
    document.addEventListener('scroll', this._displayAfterScroll)
  }

  displayAfterScroll = () => {
    const height = document.body.offsetHeight - 200
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop

    this.setState(({ displayed: stateDisplayed }) => {
      const displayed = scrollPosition >= height
      if (stateDisplayed !== displayed) {
        return { displayed }
      }
      return {}
    })
  }

  destroyScrollListener = () => {
    if (this._displayAfterScroll) {
      document.removeEventListener('scroll', this._displayAfterScroll)
    }
  }

  render () {
    const { props, state } = this
    const { className } = props
    const { displayed } = state

    return (
      <Button
        type={TYPES.ICON}
        icon={ICON_TYPES.CHEVRON_UP}
        className={getBackToTopClassName(className, displayed)}
        onClick={() => backToTopOnClick()}
      />
    )
  }
}

BackToTop.propTypes = {
  className: PropTypes.array,
}

export default BackToTop
